import React, { Component } from 'react';
import { urlApi } from '../Constants/Global';
import { Container, Carousel, Row, Col } from 'react-bootstrap';

export class SectionCarousel extends Component {
  scrollToTarget(v_target) {
    var target = document.getElementById(v_target);
    window.scrollTo({
      top: target.offsetTop - 125,
      behavior: 'smooth'
    });
  }

  render() {
    return (
      <>
        <Container fluid className="px-0">
          <Carousel>
            {this.props.contents.map((item, index) => (
              <Carousel.Item className="bg-img ratio-21x9" key={index} style={{ backgroundImage: 'url(' + urlApi + '/storage/slide/' + item.row_value + ')' }}>
                <Row>
                  <Col>
                    <Carousel.Caption className="text-end">
                      <div className='position-relative h-100'>
                        <div className='position-absolute top-50 start-0 translate-middle-y p-3 p-md-5 me-0 me-md-5'>
                          <h1 className="ifn-header mb-3">{item.name}</h1>
                          <h3 className="font-handwrite" dangerouslySetInnerHTML={{ __html: item.detail.replace(/\n/g, '<br/>') }}></h3>
                          {/* <img src={Cert1} alt="GHP" className="logo-ghp ms-5 me-5" />
                        <img src={Cert2} alt="GHP" className="logo-ghp ms-5 me-5" /> */}
                          {/* <h3 className="obj-certify">
                          โรงงานผลิตภายใต้ระบบมาตรฐาน
                          <b>GHP (Good Hygiene Practice(s))</b>
                          และ
                          <b>ISO 9001</b>
                          มาตรฐานความปลอดภัยทางอาหาร
                        </h3> */}
                        </div>
                      </div>
                    </Carousel.Caption>
                  </Col>
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </>
    )
  }
}

SectionCarousel.defaultProps = {
  contents: []
}

export default SectionCarousel